<template>
  <div
    v-if="subscription && !loading"
    class="p-4"
  >
    <hr class="divider divider--small pb-2">
    <h4
      class="font-bold text-grey-darkest"
      v-text="'Payment Summary'"
    />
    <ul style=" margin-block-start: 0;padding-inline-start: 1rem;">
      <li class="py-1">
        <strong
          class="text-grey-darker"
          v-text="`${membershipFee.attributes.title} Amount: `"
        />
        <i
          class="text-grey-darker"
          v-text="duesAmount"
        />
      </li>
      <li class="py-1">
        <strong
          class="text-grey-darker"
          v-text="'Payment Schedule: '"
        />
        <i
          class="text-grey-darker"
          v-text="paymentSchedule"
        />
      </li>
      <li class="py-1">
        <strong
          class="text-grey-darker"
          v-text="'Next Payment Due: '"
        />
        <i
          class="text-grey-darker"
          v-text="nextPaymentDueDate"
        />
      </li>
    </ul>
  </div>
</template>

<script type="text/babel">
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'MembershipFee',
  props: {
    membershipUuid: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      loading: true,
    }
  },
  computed: {
    ...mapState({
      membershipFee: state => state.payments.membershipFee,
    }),
    ...mapGetters({
      subscription: 'membershipSubscription',
    }),
    nextPaymentDueDate() {
      return this.subscription.hasOwnProperty('attributes')
        ? this.$date.toMomentDateFormat(this.subscription.attributes.current_period_end * 1000)
        : ''
    },
    duesAmount() {
      const amount = this.subscription.hasOwnProperty('attributes')
        ? this.subscription.attributes.items.data[0].plan.amount
        : ''

      return amount ? `$${(amount / 100).toFixed(2)}` : amount
    },
    paymentSchedule() {
      const interval = this.subscription.hasOwnProperty('attributes')
        ? this.subscription.attributes.items.data[0].plan.interval_count
        : ''

      switch (interval) {
        case 1:
          return 'Monthly'
        case 6:
          return 'Bi-Annually'
        case 12:
          return 'Annually'
        default:
          return ''
      }
    },
  },
  mounted() {
    this.paymentsGetMembershipFee().then((result) => {
      this.membershipGetMembership({
        membershipUuid: this.membershipUuid,
        params: {
          include: 'subscription',
        },
      }).then((result) => {
        this.loading = false
      })
    })
  },
  methods: {
    ...mapActions([
      'paymentsGetMembershipFee',
      'membershipGetMembership',
    ]),
  },
}
</script>
